
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";

import { ELNStore } from '../../store'

import { toStartOfDay, penceToCurrency, OrderIcon, StatusToken, inPast, ELAN_BRAND_ID, OrderToken, isApprovableShop, canApproveOrder } from '../../helpers/utils'
import { Loader } from '../../helpers/loader'


import { format, isEqual } from 'date-fns'
import Cal from '../../components/Cal'
import { supabase } from '../../api'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk, faSyncAlt, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import cloneDeep from "clone-deep";

export const Orders = ({ match }) => {



  const currentUser = ELNStore.useState(s => s.currentUser);

  const dateStr = match.params.date;
  const currentDateFromPath = toStartOfDay(new Date(dateStr))
  let currentDate = ELNStore.useState(s => s.currentDate);

  const [ordersToApprove, setOrdersToApprove] = useState([])

  if (!isEqual(currentDateFromPath, currentDate)) {
    ELNStore.update(s => { s.currentDate = currentDateFromPath })
    currentDate = currentDateFromPath
  }

  const [orders, setOrders] = useState(null)
  const [loading, setLoading] = useState()

  const [approving, setApproving] = useState(false)

  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      await getOrders()
      setLoading(false)
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateStr])

  const getOrders = async () => {
    let op = 'not.eq'
    let arr = '0'

    if (!currentUser.admin) {
      op = 'in'
      arr = `(${currentUser.shops.map(s => s.id)})`
    }

    const { data, error } = await supabase
      .from('orders')
      .select('*, orderProducts (quantity, unit_cost), orderCustoms (*)')
      .match({ delivery_dt: format(new Date(currentDate), 'yyyy-MM-dd') })
      .filter('shop_id', op, arr)

    if (error) console.error('error getting orders', error)
    if (data) {

      let orders = [...data]

      orders.forEach(o => {
        const shop = currentUser.shops.find(s => s.id === o.shop_id)

        o.shop = shop
        if (o.order_type === 0) {
          o.items = o.orderProducts?.reduce(function (acc, row) { return acc + (row.quantity) }, 0)
          o.total = o.orderProducts?.reduce(function (acc, row) { return acc + (row.quantity * row.unit_cost) }, 0)
        }
        else {
          o.items = o.orderCustoms?.length || 0
          o.total = o.orderCustoms?.reduce((agg, oc) => agg + oc.unit_cost, 0);

        }
      })

      orders = orders.sort((a, b) => `${a.shop?.brands?.name}  ${a.shop?.name}` > `${b.shop?.brands?.name}  ${b.shop?.name}` ? 1 : -1)

      setOrders(orders)

    }
  }

  if (loading || !orders) return (
    <>
      <Cal gridPage />
      <div className='outer'>
        <br /><br /><br /><br />
        <Loader />
      </div>
    </>
  )

  

  const toggleApproveAll = (e) => {

    const approvableOrdersForELAN = orders?.filter(o => canApproveOrder(o))

    if (e.target.checked) {
      setOrdersToApprove(approvableOrdersForELAN.map(o => o.id))
    }
    else {
      setOrdersToApprove([])
    }

  }

  const toggleApproveOrder = (orderId, isChecked) => {
    if (isChecked) {
      setOrdersToApprove([...ordersToApprove, orderId])
    }
    else {
      setOrdersToApprove([...ordersToApprove.filter(o => o !== orderId)])
    }
  }

  const doApproveAll = async () => {

    setApproving(true)

    const ordersToUpdate = ordersToApprove.map(id => ({
      id,
      approved_at: new Date().toISOString(),
      approved_by: currentUser.id,
    }))

    const { error: approvalError } = await supabase
      .from('orders')
      .upsert(ordersToUpdate)

    if (approvalError) {
      console.error(approvalError)
      setOrdersToApprove([])
      setApproving(false)
      return

    }

    const newOrders = cloneDeep(orders)
    for (let i = 0; i < ordersToUpdate.length; i++) {
      const o = newOrders.find(o => Number(o.id) === Number(ordersToUpdate[i].id))
      if (o) {
        o.approved_at = ordersToUpdate[i].approved_at
        o.approved_by = ordersToUpdate[i].approved_by
      }
    }
    setOrders(newOrders)

    setApproving(false)

  }


  let lastBrandName = ''

  let totalItems = 0
  let totalCost = 0

  if (!currentUser) return ''




  const numApprovableOrders = orders?.filter(o => canApproveOrder(o)).length || 0

  return (
    <>
      <Cal gridPage />

      <div className='outer' style={{ zIndex: 10, marginTop: -20 }}>
        <h2 style={{ marginLeft: -70 }}>For delivery on</h2>
        <h1 style={{ marginLeft: -35, marginBottom: 10, fontSize: 23, fontWeight: 'bold' }}>{format(currentDate, 'PPPP')}</h1>

        <div className='table-wrapper max'>
          <table className='orders-list'>
            <thead>
              <tr>
                <th>Shop</th>
                <th>Order num</th>
                <th>PO num</th>
                <th>Status</th>
                <th style={{ textAlign: 'center' }}>{currentUser.admin && <FontAwesomeIcon icon={faUserCheck} />}</th>
                <th className='right'>Items</th>
                <th className='right'>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{orders.map(o => {

              const shop = currentUser.shops.find(s => s.id === o.shop_id)


              const showBrandName = shop.brands?.name !== lastBrandName
              lastBrandName = shop.brands?.name || ''

              if (!o.voided) {
                totalItems += o.items
                totalCost += o.total
              }

              const isApprovable = currentUser.admin && canApproveOrder(o)

              const toggleApprove = (e) => {
                toggleApproveOrder(o.id, e.target.checked)
              }

              return (<React.Fragment key={o.id}>{showBrandName && <tr key={`brand-${shop.id}`} className='brand'>
                <td colSpan={5}><h2><br />{shop.brands.name}</h2></td>
                <td colSpan={3}></td>
              </tr>}<tr key={o.id} className={`${o.voided ? 'voided' : ''}`}>
                  <td>{shop.name}{shop.active ? '' : <i>inactive</i>}</td>
                  <td className='no-wrap'><OrderIcon order={o} />&nbsp;<strong>{o.id}</strong></td>
                  <td>{o.purchase_order_num}</td>
                  <td><StatusToken order={o} /></td>
                  <td style={{ textAlign: 'center' }}>{isApprovable && <input type="checkbox" checked={ordersToApprove.includes(o.id)} onChange={toggleApprove} />}</td>
                  <td className='right'>{o.items}</td>
                  <td className='right'>{penceToCurrency(o.total)}</td>
                  <td><OrderToken order={o} />
                    {o.is_altered && <div title='This order has changed since import' className='changes-since-import'><FontAwesomeIcon icon={faAsterisk} /></div>}
                  </td>
                </tr></React.Fragment>)
            })}</tbody>
            <tfoot>
              <tr>
  
                <td colSpan={5} style={{ textAlign: 'right', paddingRight: 14 }}>{currentUser.admin && numApprovableOrders > 0 && <><button disabled={ordersToApprove.length === 0} className='inv sml' onClick={doApproveAll}><FontAwesomeIcon spin={approving} icon={approving ? faSyncAlt : faUserCheck} /> Approve{ordersToApprove.length>0 ? ` ${ordersToApprove.length} selected` : ' all'}</button>&nbsp;&nbsp;<input type="checkbox" onChange={toggleApproveAll} /></>}</td>
                
                <td className='right'>{totalItems}</td>
                <td className='right'>{penceToCurrency(totalCost)}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

      </div>
    </>
  )
}

export default withRouter(Orders);
